import { useEffect, useState } from 'react';

/**
 * Хук для формирования ссылки на Яндекс.Паспорт с учетом окружения
 * @returns {String} Ссылка на страницу авторизации Яндекс.Паспорта
 */
export const usePassportLink = (): string => {
    const [passportLink, setPassportLink] = useState('https://passport.yandex.ru/auth/welcome');

    useEffect(() => {
        const retpath = encodeURIComponent(window.location.href);
        const host = process.env.NODE_ENV === 'development' ? 'passport-test.yandex.ru' : 'passport.yandex.ru';

        setPassportLink(`https://${host}/auth/welcome?mode=auth&retpath=${retpath}`);
    }, []);

    return passportLink;
};
